import { render, staticRenderFns } from "./OfficeSmtpSetup.vue?vue&type=template&id=3ec13a0c&scoped=true"
import script from "./OfficeSmtpSetup.vue?vue&type=script&lang=js"
export * from "./OfficeSmtpSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec13a0c",
  null
  
)

export default component.exports